import React from 'react'

function Team() {
  return (
    <section className="text-[#244566] bg-[#e9eef4] flex flex-col justify-center items-center space-y-14 pt-6 pb-14">
          <h3 className="text-2xl font-semibold">OUR TEAM</h3>
          <p className="px-5 xl:w-[60%] text-center leading-tight text-xl">Our team is formed by ex bankers with more than 10 Years experience In mortgage
related field & well trained members. A total of 20 Members are ready to provide you with top services.</p>
        </section>
  )
}

export default Team